<template>
  <path id="ic_pause_24px" d="M6,40.841H16.24V5H6ZM26.481,5V40.841H36.721V5Z" transform="translate(-6 -5)" />
</template>
